import script from "./LkCheckbox.vue?vue&type=script&lang=js"
export * from "./LkCheckbox.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__